export const ZOOM_LEVEL = {
  low: 10,
  medium: 8,
  high: 6,
  extreme: 4,
};
